import { render, staticRenderFns } from "./BaseDetailUrl.vue?vue&type=template&id=55b0ccd3"
import script from "./BaseDetailUrl.vue?vue&type=script&lang=js"
export * from "./BaseDetailUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports